import { NoteView } from '@ndvr/customer-api';

import type { TenantTeamNameResolver } from 'views/admin/tenantTeam/tenant-team-queries';

export const MEETING_ASSISTANT_GUID = 'b2084a2d-4c39-4016-a77f-f6bacc8ec3cf';
export const MEETING_ASSISTANT_NAME = 'Claire';

/** Display name for a note author or assignee: the meeting assistant, a tenant team member, or a fallback. */
export const getNotePersonName = (personId: string, nameFor: TenantTeamNameResolver): string => {
    if (personId === MEETING_ASSISTANT_GUID) {
        return `${MEETING_ASSISTANT_NAME}™`;
    }
    return nameFor(personId) ?? `Unknown Advisor - ${personId}`;
};

type FilterNoteOptions = { searchTerm?: string };

export const filterNotes = (notes: NoteView[], { searchTerm }: FilterNoteOptions): NoteView[] => {
    const search = searchTerm?.toLowerCase().trim();
    if (!search) {
        return notes;
    }

    return notes.filter(
        (note) => note.subject.toLowerCase().includes(search) || note.content.toLowerCase().includes(search),
    );
};

/** GUIDs of pinned notes, most recently pinned first — the order they appear at the top of the list. */
export const getPinnedNoteGUIDs = (notes: NoteView[]): string[] =>
    notes
        .filter((note) => !!note.pinnedAt)
        .sort((a, b) => new Date(b.pinnedAt!).getTime() - new Date(a.pinnedAt!).getTime())
        .map((note) => note.noteGUID);
